<template>
  <div class="Add_scale">

    <el-form ref="form" :model="form" label-width="80px" style="padding-top: 20px;margin-left: 20px;">

      <el-form-item label="量表归类">
        <el-input v-model="form.a1" placeholder="量表归类"></el-input>
      </el-form-item>

      <el-form-item label="量表代号">
        <el-input v-model="form.a2" placeholder="量表代号"></el-input>
      </el-form-item>

      <el-form-item label="量表名称">
        <el-input v-model="form.a3" placeholder="量表名称"></el-input>
      </el-form-item>

      <el-form-item label="量表封面">
        <div class="cover" style="margin-left:-70px">
          <el-upload :on-change="handleChange" :auto-upload="false" class="avatar-uploader" action="" :show-file-list="false" accept="image/jpeg,image/gif,image/png">
            <img v-if="form.imageUrl" :src="form.imageUrl" class="avatar" />
            <i v-else class="el-icon-plus avatar-uploader-icon">
              <span style="font-size: 16px;">点击选择封面</span>
            </i>
          </el-upload>
        </div>
      </el-form-item>

      <el-form-item label="内容图片">
        <div class="cover" style="margin-left:-70px">
          <el-upload :on-change="handleChange2" :auto-upload="false" class="avatar-uploader" action="" :show-file-list="false" accept="image/jpeg,image/gif,image/png">
            <img v-if="form.imageUrl2" :src="form.imageUrl2" class="avatar" />
            <i v-else class="el-icon-plus avatar-uploader-icon">
              <span style="font-size: 16px;">点击选择封面</span>
            </i>
          </el-upload>
        </div>
      </el-form-item>

      <el-form-item label="活动形式">
        <el-input type="textarea" v-model="form.a5"  placeholder="活动形式"></el-input>
      </el-form-item>

      <el-form-item label="量表转换公式">
        <el-select v-model="form.a6" placeholder="量表转换公式">
          <el-option label="125*X/100" value="125*X/100"></el-option>
          <el-option label="Z=(X-A)/SD" value="Z=(X-A)/SD"></el-option>
          <el-option label="T=50+10*Z" value="T=50+10*Z"></el-option>
          <el-option label="5+2*Z" value="5+2*Z"></el-option>
          <el-option label="10+3*Z" value="10+3*Z"></el-option>
          <el-option label="100+15*Z" value="100+15*Z"></el-option>
          <el-option label="标准分=1.5*X" value="标准分=1.5*X"></el-option>
          <el-option label="对照常模" value="对照常模"></el-option>
          <el-option label="标准分=1.19*X" value="标准分=1.19*X"></el-option>
          <el-option label="标准分=1.25*X" value="标准分=1.25*X"></el-option>
          <el-option label="标准分=原始分" value="标准分=原始分"></el-option>
          <el-option label="无标准分" value="无标准分"></el-option>
          <el-option label="5.5+1.5*Z" value="5.5+1.5*Z"></el-option>
          <el-option label="55+10*Z" value="55+10*Z"></el-option>
          <el-option label="X/105*100" value="X/105*100"></el-option>
          <el-option label="标准分=(X-8)*100/32" value="标准分=(X-8)*100/32"></el-option>
          <el-option label="标准分=(X-6)*100/24" value="标准分=(X-6)*100/24"></el-option>
          <el-option label="标准分=(X-5)*100/20" value="标准分=(X-5)*100/20"></el-option>
          <el-option label="标准分=(X-4)*100/16" value="标准分=(X-4)*100/16"></el-option>
          <el-option label="6+1.5*(X-A)/SD" value="6+1.5*(X-A)/SD"></el-option>
          <el-option label="60+15*(X-A)/SD" value="60+15*(X-A)/SD"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="常模类型">
        <el-select v-model="form.a7" placeholder="量表转换公式">
          <el-option label="一类常模" value="一类常模"></el-option>
          <el-option label="二类常模" value="二类常模"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="年龄段">
        <el-input placeholder="开始年龄段" style="width: 100px !important;" v-model="form.a8"></el-input> - <el-input style="width: 100px !important;" v-model="form.a9" placeholder="结束年龄段"></el-input>
      </el-form-item>

      <el-form-item label="性别">
        <el-radio-group v-model="form.a9">
          <el-radio label="不区分"></el-radio>
          <el-radio label="男"></el-radio>
          <el-radio label="女"></el-radio>
        </el-radio-group>
      </el-form-item>

      <el-form-item label="标准分">
        <el-input v-model="form.a10" placeholder="标准分"></el-input>
      </el-form-item>

      <el-form-item label="平均数">
        <el-input v-model="form.a11" placeholder="平均数"></el-input>
      </el-form-item>

      <el-form-item label="量表排序">
        <el-input v-model="form.a12" placeholder="量表排序"></el-input>
      </el-form-item>

      <el-form-item label="量表基准分">
        <el-input v-model="form.a13" placeholder="量表基准分"></el-input><span style="color: red;">说明:只能输入数字</span> 
      </el-form-item>

      <el-form-item label="量表计时">
        <el-input v-model="form.a14" placeholder="量表计时"></el-input> 单位：秒 <span style="color: red;">单位：秒 说明:只能输入数字。</span> 
      </el-form-item>

      <el-form-item label="量表限时">
        <el-input v-model="form.a15" placeholder="量表限时"></el-input> 单位：秒 <span style="color: red;">单位：秒 说明:只能输入数字。</span> 
      </el-form-item>

      <el-form-item label="量表题目计时">
        <el-input v-model="form.a16" placeholder="量表题目计时"></el-input> 单位：秒 <span style="color: red;">单位：秒 说明:只能输入数字。</span> 
      </el-form-item>

      <el-form-item label="量表题目限时">
        <el-input v-model="form.a17" placeholder="量表题目限时"></el-input> 单位：秒 <span style="color: red;">单位：秒 说明:只能输入数字。</span> 
      </el-form-item>

      <el-form-item label="量表其它设置">
        <el-radio-group v-model="form.a18">
          <el-radio label="是否有因子"></el-radio>
          <el-radio label="是否允许漏题"></el-radio>
          <el-radio label="是否有均分"></el-radio>
        </el-radio-group>
      </el-form-item>

      <el-form-item label="量表报告展示">
        <el-radio-group v-model="form.a19">
          <el-radio label="原始分	"></el-radio>
          <el-radio label="标准分"></el-radio>
          <el-radio label="均分"></el-radio>
          <el-radio label="常模"></el-radio>
          <el-radio label="总分"></el-radio>
          <el-radio label="参考诊断"></el-radio>
        </el-radio-group>
      </el-form-item>

      <el-form-item label="量表报告展示">
        <el-radio-group v-model="form.a20">
          <el-radio label="结果等级	"></el-radio>
          <el-radio label="危机预警"></el-radio>
        </el-radio-group>
      </el-form-item>

      <el-form-item label="因子分">
        <el-radio-group v-model="form.a21">
          <el-radio label="选择"></el-radio>
        </el-radio-group>
      </el-form-item>

      <el-form-item label="量表分">
        <el-radio-group v-model="form.a22">
          <el-radio label="选择"></el-radio>
        </el-radio-group>
      </el-form-item>

      <el-form-item label="原始分取值方式">
        <el-radio-group v-model="form.a23">
          <el-radio label="原始取值"></el-radio>
          <el-radio label="按模取值"></el-radio>
          <el-radio label="四舍五入"></el-radio>
          <el-radio label="四入五入"></el-radio>
        </el-radio-group>
      </el-form-item>

      <el-form-item label="标准分取值方式">
        <el-radio-group v-model="form.a24">
          <el-radio label="原始取值"></el-radio>
          <el-radio label="按模取值"></el-radio>
          <el-radio label="四舍五入"></el-radio>
          <el-radio label="四入五入"></el-radio>
        </el-radio-group>
      </el-form-item>

      <el-form-item label="平均分取值方式">
        <el-radio-group v-model="form.a25">
          <el-radio label="原始取值"></el-radio>
          <el-radio label="按模取值"></el-radio>
          <el-radio label="四舍五入"></el-radio>
          <el-radio label="四入五入"></el-radio>
        </el-radio-group>
      </el-form-item>

      <el-form-item label="平均分公式">
        <el-input type="textarea" v-model="form.a26" placeholder="平均分公式"></el-input>
      </el-form-item>

      <el-form-item label="功能说明">
        <el-input type="textarea" v-model="form.a27" placeholder="功能说明"></el-input>
      </el-form-item>

      <el-form-item label="指 导 语">
        <el-input type="textarea" v-model="form.a28" placeholder="指 导 语"></el-input>
      </el-form-item>

      <el-form-item label="推 荐 语">
        <el-input type="textarea" v-model="form.a29" placeholder="推 荐 语"></el-input>
      </el-form-item>

      <el-form-item label="计分标准">
        <el-input type="textarea" v-model="form.a30" placeholder="计分标准"></el-input>
      </el-form-item>

      <el-form-item label="测评理论">
        <el-input type="textarea" v-model="form.a31" placeholder="测评理论"></el-input>
      </el-form-item>

      <el-form-item label="参考文献">
        <el-input type="textarea" v-model="form.a32" placeholder="参考文献"></el-input>
      </el-form-item>

      <el-form-item label="适用范围">
        <el-input type="textarea" v-model="form.a33" placeholder="适用范围"></el-input>
      </el-form-item>

      <el-form-item label="测试效果">
        <el-input type="textarea" v-model="form.a34" placeholder="测试效果"></el-input>
      </el-form-item>

      <el-form-item label="是否启用">
        <el-radio-group v-model="form.a35">
          <el-radio label="是"></el-radio>
          <el-radio label="否"></el-radio>
        </el-radio-group>
      </el-form-item>

      <el-form-item label="标签">
        <el-input v-model="form.a36" placeholder="标签"></el-input>
      </el-form-item>
      
      <!-- <el-form-item>
        <el-button type="primary" @click="onSubmit">立即创建</el-button>
        <el-button>取消</el-button>
      </el-form-item> -->
    </el-form>
  </div>
</template>
<script>
  export default {
    data() {
      return {
        form: {
          imageUrl: '',
          imageUrl2: '',
          a1: '',
          a2: '',
          a3: '',
          a4: '',
          a5: '',
          a6: '',
          a7: '',
          a8: '',
          a9: '',
          a10: '',
          a11: '',
          a12: '',
          a13: '',
          a14: '',
          a15: '',
          a16: '',
          a17: '',
          a18: '',
          a19: '',
          a20: '',
          a21: '',
          a22: '',
          a23: '',
          a24: '',
          a25: '',
          a26: '',
          a27: '',
          a28: '',
          a29: '',
          a30: '',
        }
      };
    },
    components:{

    },
    methods: {
      onSubmit() {
        console.log('submit!');
      },
      handleChange(file, fileList) {
        this.form.imageUrl = URL.createObjectURL(file.raw);
        this.form.a4 = file.raw;
      },
      handleChange2(file, fileList) {
        this.form.imageUrl2 = URL.createObjectURL(file.raw);
        this.form.a4 = file.raw;
      },
    }
  };
</script>
<style>
.Add_scale{width: 100%;height: 100%;background-color: #fff;overflow: auto;}
.Add_scale .el-input{width: 300px;}

.Add_scale .el-textarea{width: 500px;}


.Add_scale .el-form-item__label{width: 100px !important;text-align: right;}

.Add_scale .el-form-item__content{margin-left: 100px !important;}














.avatar-uploader-icon {font-size: 28px;color: #8c939d;width: 215px;height: 148px;line-height: 148px;text-align: center;border: 1px solid #d1d1d1;}
.avatar {width: 215px;height: 148px;display: block;}
.cover {margin-left: 10px;font-size: 14px;vertical-align: middle;box-sizing: border-box;position: relative;color: #606266;height: 150px;}
.avatar-uploader {position: absolute;top: 0px;left: 70px;}
.cover p {font-size: 14px;color: rgba(158, 158, 158, 1);position: absolute;top: 0px;left: 297px;width: 350px;}
.scale {margin-top: 30px;}
</style>